




























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import AgencyDto from '@/models/Agencies/AgencyDto';
import CreateAgencyRequest from '@/models/Agencies/CreateAgencyRequest';
import Validator from '@/lib/validator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencyModule } from '@/store/modules/agency';
import ListUtils from '@/lib/listUtils';
import AddressUtils from '@/lib/addressUtils';
import CountryIso from '@/lib/countryIso';
import GeoPoint from '@/models/Shared/GeoPoint';

@Component({
    name: 'AgencyCreate'
})
export default class extends GiganautVueDialog {
 
  entity = new AgencyDto();
  country: CountryIso = new CountryIso();
  addressSearchText = '';
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new AgencyDto();
      this.country = new CountryIso();
      this.addressSearchText = '';
    }
  }

  get brandThemeModes() {
    return ListUtils.brandThemeModes();
  }

  get loading() {
    return AgencyModule.loadingDialog;
  }

  get isoCountries() {
    return AddressUtils.isoCountries();
  }

  async getAddressData(addressData: any, placeData: any) {
    this.entity.buildingNameNumber = addressData.street_number ? addressData.street_number:'';
    this.entity.streetRoadBlock = addressData.route ? addressData.route:'';
    this.entity.locality = addressData.locality ? addressData.locality:'';
    //Pick out the postal town
    for (let index = 0; index < placeData.address_components.length; index++) {
      const element = placeData.address_components[index];
      if (element.types[0] === "postal_town"){
        this.entity.cityTown = element.long_name;
      }
      
    }
    //Pick out the country code
    for (let index = 0; index < placeData.address_components.length; index++) {
      const element = placeData.address_components[index];
      const isoCountriesLocal = this.isoCountries;
      if (element.types[0] === "country"){
        for (let countryIndex = 0; countryIndex < isoCountriesLocal.length; countryIndex++) {
          if (isoCountriesLocal[countryIndex].code === element.short_name) {
            this.country = isoCountriesLocal[countryIndex];
          }
        }
      }   
    }
    this.entity.stateProvinceRegion = addressData.administrative_area_level_2 ? addressData.administrative_area_level_2:'';
    this.entity.postZipCode = addressData.postal_code ? addressData.postal_code:'';
    this.entity.geometry.lat = addressData.latitude;
    this.entity.geometry.lng = addressData.longitude;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateAgencyRequest()
    request.registeredName = this.entity.registeredName;
    request.buildingNameNumber = this.entity.buildingNameNumber;
    request.streetRoadBlock = this.entity.streetRoadBlock;
    request.locality = this.entity.locality;
    request.cityTown = this.entity.cityTown;
    request.stateProvinceRegion = this.entity.stateProvinceRegion;
    request.postZipCode = this.entity.postZipCode;
    request.countryCode = this.country.code;
    request.geometry = new GeoPoint();
    request.geometry.lat = Number(this.entity.geometry.lat);
    request.geometry.lng = Number(this.entity.geometry.lng);
    request.registrationNumber = this.entity.registrationNumber;
    request.taxNumber = this.entity.taxNumber;
    request.biography = this.entity.biography;
    request.website = this.entity.website;
    request.brandName = this.entity.brandName;
    request.brandPrimaryColour = this.entity.brandPrimaryColour;
    request.brandThemeMode = this.entity.brandThemeMode;

    await AgencyModule.createAgency(request)
    this.dialog = false;
  }
}
